export default __webpack_public_path__ + "static/media/G0005.6daefb86.png";